<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head">T<span class="small">ABLE OF</span> C<span class="small">ONTENTS</span> &amp; M<span class="small">AP</span> K<span class="small">EY</span></p>
<table>
<colgroup>
<col width="90px"/>
<col width="300px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Welcome_spooky#Wel">Welcome to Spooky Dallas!</a></td></tr>
<tr><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Chapter 1.</span></td><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Downtown Disturbances</span></td></tr>
<tr><td>1</td><td>Texas School Book Depository</td></tr>
<tr><td>2</td><td>Majestic Theater</td></tr>
<tr><td>3 <span href="#/Chapter02#C2" title="Link target outside of Sample">Chapter 2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Old Souls in Old City Park</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Chapter 3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Haunted Hotels and Cemeteries</span></td></tr>
<tr><td>4</td><td>The Adolphus Hotel</td></tr>
<tr><td>5</td><td>The Stoneleigh Hotel</td></tr>
<tr><td>6</td><td>Hotel Lawrence</td></tr>
<tr><td>7</td><td>Baccus Cemetery</td></tr>
<tr><td>8</td><td>Pleasant Valley Cemetery</td></tr>
<tr><td>9</td><td>Mills Cemetary</td></tr>
<tr><td>10 <span href="#/Chapter04#C4" title="Link target outside of Sample">Chapter 4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Strange Sights at Snuffer’s</span></td></tr>
<tr><td>11 <span href="#/Chapter05#C5" title="Link target outside of Sample">Chapter 5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">The Lady of White Rock Lake</span></td></tr>
<tr><td>12 <span href="#/Chapter06#C6" title="Link target outside of Sample">Chapter 6.</span></td><td><span href="#/Chapter06#C6" title="Link target outside of Sample">Unexpected Experiences at Unity of Dallas</span></td></tr>
<tr><td>13 <span href="#/Chapter07#C7" title="Link target outside of Sample">Chapter 7.</span></td><td><span href="#/Chapter07#C7" title="Link target outside of Sample">Ghosts with Good Taste</span></td></tr>
<tr><td>13</td><td>The Dallas Arboretum and Botanical Garden</td></tr>
<tr><td>14</td><td>DeGolyer House</td></tr>
<tr><td>15</td><td>Sons of Hermann Hall</td></tr>
<tr><td>16</td><td>Sammons Center for the Arts</td></tr>
<tr><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Chapter 8.</span></td><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Spooky Suburbs</span></td></tr>
<tr><td>17</td><td>Red Oak</td></tr>
<tr><td>18</td><td>Waxahachie</td></tr>
<tr><td>19</td><td>Cleburne</td></tr>
<tr><td>20 <span href="#/Chapter09#C9" title="Link target outside of Sample">Chapter 9.</span></td><td><span href="#/Chapter09#C9" title="Link target outside of Sample">Mysteries in McKinney</span></td></tr>
<tr><td colspan="2"><span href="#/Ghostly_goodbye#Ghos" title="Link target outside of Sample">A Ghostly Goodbye</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?6d9913a9